import { useDispatch } from '../store'
import { updateDefaultWallet } from '../store/authSlice'

export const useUpdateDefaultWallet = () => {
  const dispatch = useDispatch()
  return (currencyCode: string) => {
    dispatch(updateDefaultWallet(currencyCode))
  }
}
